import { HashRouter, Route, Routes } from 'react-router-dom'
import HomePage from './pages/Home'
import TeacherPage from './pages/Teacher'
import StudentPage from './pages/Student'
import ExtractionPage from './pages/QuestionBank/Extraction'
import { TutorLayout } from './components/tutor/TutorLayout'
import KnowledgePointsPage from './pages/KnowledgePoints'
import ExamListPage from './pages/Exam/List'
import ExamDetailPage from './pages/Exam/Detail'
import ExamHistoryPage from './pages/Exam/History'
import PaperEditorPage from './pages/PaperEditor'
import ExamSessionPage from './pages/Exam/Session'
import ExamDiagnosisPage from './pages/Exam/Diagnosis'
import ExplanationPlayerPage from './pages/Exam/ExplanationPlayer'
import MistakeListPage from './pages/Mistakes/List'
import MistakeDetailPage from './pages/Mistakes/Detail'
import FlashcardDeckListPage from './pages/Flashcards/DeckList'
import FlashcardDeckDetailPage from './pages/Flashcards/DeckDetail'
import FlashcardStudyPage from './pages/Flashcards/Study'
import LoginPage from './pages/Login'
import RegisterPage from './pages/Register'
import { RequireAuth } from './components/RequireAuth'
import { Toaster } from './components/ui/sonner'
import TutorVisualizationPage from './pages/TutorVisualization'
import GeomasterStudioPage from './pages/GeomasterStudio'
import XiaoHuaPage from './pages/XiaoHua'
import AITeamDashboard from './pages/AITeam/Dashboard'
import AITeamDiagnosis from './pages/AITeam/Diagnosis'
import AITeamCourses from './pages/AITeam/Courses'
import AITeamCourseDetail from './pages/AITeam/CourseDetail'
import AITeamLessonPlayer from './pages/AITeam/LessonPlayer'
import AITeamDailyTasks from './pages/AITeam/DailyTasks'
import AITeamNewCourse from './pages/AITeam/NewCourse'
import { PlanList as ExamPrepPlanList } from './pages/ExamPrep'
import { NewPlan as ExamPrepNewPlan } from './pages/ExamPrep'
import { PlanDetail as ExamPrepPlanDetail } from './pages/ExamPrep'
import SharedLessonPage from './pages/SharedLesson'
import LessonPrintPage from './pages/LessonPrint'
import WeChatBindingPage from './pages/WeChatBinding'
import QuestionPlayerPage from './pages/QuestionPlayer'
import { AppLayout } from './components/layout/AppLayout'
import { ROUTES } from './constants/routes'

export default function App() {
  return (
    <HashRouter>
      <Routes>
        {/* 公共路由 - 无侧边栏 */}
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
        <Route path={ROUTES.SHARE} element={<SharedLessonPage />} />

        {/* 沉浸式路由 - 无侧边栏（考试会话等） */}
        <Route element={<RequireAuth><AppLayout hideSidebar /></RequireAuth>}>
          <Route path={ROUTES.EXAM_SESSION} element={<ExamSessionPage />} />
          <Route path={ROUTES.TEACHER_PRINT} element={<LessonPrintPage />} />
        </Route>

        {/* 主应用路由 - 带侧边栏 */}
        <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.STUDENT} element={<StudentPage />} />

          {/* 教师模块 */}
          <Route path={ROUTES.TEACHER} element={<TeacherPage />} />
          <Route path={ROUTES.TEACHER_LESSON} element={<TeacherPage />} />

          {/* 考试模块 */}
          <Route path={ROUTES.EXAM} element={<ExamListPage />} />
          <Route path={ROUTES.EXAM_HISTORY} element={<ExamHistoryPage />} />
          <Route path={ROUTES.EXAM_PAPER} element={<ExamDetailPage />} />
          <Route path={ROUTES.EXAM_EDITOR} element={<PaperEditorPage />} />
          <Route path={ROUTES.EXAM_DIAGNOSIS} element={<ExamDiagnosisPage />} />
          <Route path={ROUTES.EXAM_EXPLANATION} element={<ExplanationPlayerPage />} />

          {/* 错题模块 */}
          <Route path={ROUTES.MISTAKES} element={<MistakeListPage />} />
          <Route path={ROUTES.MISTAKE_DETAIL} element={<MistakeDetailPage />} />

          {/* 闪卡模块 */}
          <Route path={ROUTES.FLASHCARDS} element={<FlashcardDeckListPage />} />
          <Route path={ROUTES.FLASHCARD_DECK} element={<FlashcardDeckDetailPage />} />
          <Route path={ROUTES.FLASHCARD_STUDY} element={<FlashcardStudyPage />} />

          {/* 自助备考模块 */}
          <Route path={ROUTES.EXAM_PREP} element={<ExamPrepPlanList />} />
          <Route path={ROUTES.EXAM_PREP_NEW} element={<ExamPrepNewPlan />} />
          <Route path={ROUTES.EXAM_PREP_DETAIL} element={<ExamPrepPlanDetail />} />

          {/* AI团队模块 */}
          <Route path={ROUTES.AI_TEAM} element={<AITeamDashboard />} />
          <Route path={ROUTES.AI_TEAM_DIAGNOSIS} element={<AITeamDiagnosis />} />
          <Route path={ROUTES.AI_TEAM_COURSES} element={<AITeamCourses />} />
          <Route path={ROUTES.AI_TEAM_NEW_COURSE} element={<AITeamNewCourse />} />
          <Route path={ROUTES.AI_TEAM_COURSE_DETAIL} element={<AITeamCourseDetail />} />
          <Route path={ROUTES.AI_TEAM_LESSON_PLAYER} element={<AITeamLessonPlayer />} />
          <Route path={ROUTES.AI_TEAM_TASKS} element={<AITeamDailyTasks />} />

          {/* 工具模块 */}
          <Route path={ROUTES.QB_EXTRACT} element={<ExtractionPage />} />
          <Route path={ROUTES.TUTOR} element={<TutorLayout />} />
          <Route path={ROUTES.TUTOR_VISUALIZATION} element={<TutorVisualizationPage />} />
          <Route path={ROUTES.QUESTION_PLAYER} element={<QuestionPlayerPage />} />
          <Route path={ROUTES.GEOMASTER} element={<GeomasterStudioPage />} />
          <Route path={ROUTES.XIAOHUA} element={<XiaoHuaPage />} />
          <Route path={ROUTES.KNOWLEDGE_POINTS} element={<KnowledgePointsPage />} />

          {/* 微信绑定 */}
          <Route path="/wechat" element={<WeChatBindingPage />} />
        </Route>
      </Routes>
      <Toaster />
    </HashRouter>
  )
}
